export default {
  namespaced: true,
  service_orders: {
    charts: {
      select: "Selecione o gráfico",
      bar: "Barras",
      pie: "Rosca",
      total: "Total de ordens",
      loading: "Carregando gráficos disponíveis…",
      load_error: "Não foi possível carregar os gráficos.",
      retry: "Tentar novamente",
      unavailable: "Não há gráficos de ordens de serviço disponíveis para seu usuário.",
      date_hint: "O período usa a data de atendimento e começa no mês atual. Use os filtros do gráfico para alterá-lo.",
    },
    title: "Ordens de serviço",
    reference_number: "Número de referência",
    company: "Empresa",
    facility: "Instalação",
    attention_date: "Data de atenção",
    date_filters: "Filtros de data",
    status: "status",
    status_change_date: "data de mudança de status",
    delete_selection: "excluir seleção",
    required_fields_to_filter_by_date: "Campos obrigatórios para filtrar por data",
    pending: "Pendente",
    in_review: "Em revisão",
    in_progress: "Em andamento",
    finished: "Finalizada",
    canceled: "Cancelada",
    show_maintenance_form: 'Mostrar formulário de manutenção'
  },
};
